module.exports = __webpack_public_path__ + "static/media/call.65d158b2.svg";